(ns frontend.view.curtains.webentry-resolution.view
  (:require
   [clojure.string :as string]
   [common.features.plan :as plan]
   [common.fields.schema :as fields]
   [common.fields.templates.company-schema :as company-schema]
   [common.localization :as loc]
   [common.schema.registry :as registry]
   [frontend.logging :as logging]
   [frontend.state.current-session :as session]
   [frontend.view.components.form.cards :as cards]
   [frontend.view.curtains.webentry-resolution.components.attachments :as attachments]
   [frontend.view.curtains.webentry-resolution.db :as db]
   [frontend.view.curtains.webentry-resolution.events :as events]
   [frontend.view.modals.confirmation.view :as confirmation]
   [frontend.view.modals.events :refer [open-modal!]]
   [frontend.view.webentry.templates.contact-schema :as contact-schema]
   [potpuri.core :as p :refer [fn->]]
   [reagent.core :as r]
   [ui.components.alert.view :as alert]
   [ui.components.button.view :as button]
   [ui.components.modal.view :as modal]))

(defn webentry-schema
  [tenant-schema]
  {:cards (for [card (:cards (company-schema/company-schema tenant-schema))]
            (assoc card
              :fields
              (map (fn [group]
                     (map (fn [field]
                            ;;force full width
                            (assoc field
                              :size
                              {:xs 12 :sm 12 :md 12}))
                          group))
                   (:fields card))))})

(def contact-schema
  {:cards (for [card (:cards contact-schema/contact-schema)]
            (assoc card
              :fields
              (map (fn [group]
                     (map (fn [field]
                            ;;force full width
                            (assoc field
                              :size
                              {:xs 12 :sm 12 :md 12}))
                          group))
                   (:fields card))))})

(defn webentry-field-filter
  [oppo company field-key]
  (let [{:keys [field-settings]} @db/state
        setting (some #{(get field-settings field-key)}
                      [:in-use :mandatory :disabled-in-use :disabled-mandatory])
        not-implemented (some #{field-key} [])]
    (and setting
         (not not-implemented)
         (or (not (string/blank? (-> company
                                     field-key)))                                                   ;;skip empty fields
             (not (string/blank? (-> oppo
                                     field-key)))))))

(defn contact-view
  [task]
  (let [task-data (:task/data task)

        ;;contact-data is divided into three parts:
        contact (:contact task-data)
        misc (:misc task-data)
        contact-involvement (:contact-involvement task-data)
        contact (merge contact misc contact-involvement)

        ;;change each attribute to match with contact-schema, i.e. :contact/ -namespaced
        contact (p/map-keys (comp (partial keyword "contact") name) contact)
        contact (clojure.set/rename-keys contact
                                         {:contact/tel          :contact/phone
                                          :contact/linkedin-url :contact/linkedin})
        contact (dissoc contact :contact/spoken-to)                                                 ;;this is shown on the top
        ]
    [:div.webentry-curtain-fields
     [:div
      (doall (for [card (:cards contact-schema)]
               ^{:key (:card-key card)}
               [cards/card-main
                (merge {:card card}
                       {:available-in-view? (fn [attr]
                                              (-> contact
                                                  attr
                                                  string/blank?
                                                  not))
                        :template-entities  {:contact contact}
                        :read-only?         true
                        :field-error?       fields/field-error?})]))]]))

;; note: copied from old webentry resolution modal. change / clean up when necessary
(defn webentry-fields
  [task]
  (let [task-data (:task/data task)
        company (:company task-data)
        oppo (:oppo task-data)
        attachments (-> task
                        :common/attachments)
        persons []
        tenant @session/tenant
        tenant-schema @session/tenant-schema
        named-value-opt-map
        (merge (->> @session/grouped-named-values
                    (map (fn [[attrib entities]]
                           [attrib
                            (->> entities
                                 (map (fn [{:keys [:db/id :named-value/value]}]
                                        {:key   id
                                         :label value})))]))
                    (into {}))
               {:company/TOL-A (->> (registry/get-field-schema tenant-schema :company/TOL-A)
                                    :options)
                :company/TOL-B (->> (registry/get-field-schema tenant-schema :company/TOL-B)
                                    :options)
                :asset/country (->> (registry/get-field-schema tenant-schema :asset/country)
                                    :options)})
        update-person-search! (fn [results]
                                (swap! db/state
                                       update
                                       :entities
                                       merge
                                       (p/index-by :db/id (mapv :person results))))]
    [:div.webentry-curtain-fields
     [:div
      (doall
       (for [card (:cards (webentry-schema tenant-schema))]
         ^{:key (:card-key card)}
         [cards/card-main
          (merge
           {:card card}
           {:available-in-view?    (fn [field-key]
                                     (let [ava? (and (webentry-field-filter oppo company field-key)
                                                     (case field-key
                                                       :company/financials false
                                                       :company/tesi-financials false
                                                       :role/guest-sell-side (plan/available
                                                                              :feature/sell-side-guest
                                                                              @db/tenant
                                                                              @db/role)
                                                       true))]
                                       ava?))
            :template-entities     {:oppo oppo :company company}
            :accounts              {}
            :edit?                 false
            :read-only?            true
            :persons               persons
            :attachments           attachments
            :options               named-value-opt-map
            :field-error?          fields/field-error?
            :update-person-search! update-person-search!})]))]]))

(defn webentry-resolution-view
  [{:keys [task resolve-webentry!]}]
  (let [processing? (r/atom false)
        processing-started (partial reset! processing? true)
        processing-ended (fn [& v]
                           (reset! processing? false)
                           (first v))]
    (fn [{:keys [task]}]
      (let [task-company-name (some-> task
                                      :task/data
                                      :company
                                      :asset/name
                                      str
                                      string/trim
                                      string/lower-case)
            existing-company (->> @session/all-companies
                                  (filter (fn [c]
                                            (-> c
                                                :asset/name
                                                string/trim
                                                string/lower-case
                                                (= task-company-name))))
                                  first)
            existing-company-id (:db/id existing-company)
            new-company? (nil? existing-company-id)
            disabled? (or @processing?
                          (nil? task)
                          (:common/disabled? task)
                          (:task/completed? task))
            message-from-sender (-> task
                                    :task/data
                                    :misc
                                    :contact/spoken-to)
            allow-contact? (->> task
                                :task/data
                                :allow-contact?
                                :checked?)
            alert (-> @db/state
                      :alert)]
        [:div.webentry-curtain-contents
         (when alert
           [alert/danger
            {:on-close events/hide-alert!}
            alert])
         [:div.webentry-curtain-info
          (if new-company?
            (loc/tr :web-form-resolution/new-company)
            (loc/tr :web-form-resolution/existing-company))]
         [:div.webentry-curtain-buttons
          [:div
           [button/danger-solid
            {:disabled? disabled?
             :on-click  (fn [_]
                          (open-modal!
                           confirmation/modal-key
                           {:body           (if-not new-company?
                                              [:div.confirm-discard
                                               [:div.confirm-discard-first
                                                (loc/tr :web-form-resolution/confirmation-existing-company)]
                                               [:div.confirm-discard-third
                                                (loc/tr :web-form-resolution/confirmation-third)]]
                                              [:div.confirm-discard
                                               [:div.confirm-discard-first
                                                (loc/tr :web-form-resolution/confirmation-first)]
                                               [:div.confirm-discard-second
                                                (loc/tr :web-form-resolution/confirmation-second)]
                                               [:div.confirm-discard-third
                                                (loc/tr :web-form-resolution/confirmation-third)]])
                            :skip-checkbox? true
                            :body-class     "text"
                            :cancel-icon    [:i.fal.fa-angle-left]
                            :cancel-text    (loc/tr :back)
                            :confirm-text   (loc/tr :web-form-resolution/discard)
                            :on-confirm     (fn [_]
                                              (processing-started)
                                              (resolve-webentry! task
                                                                 true
                                                                 existing-company-id
                                                                 (fn [_]
                                                                   (processing-ended)
                                                                   (events/close-curtain!))
                                                                 (fn [e]
                                                                   (logging/warn
                                                                    "Failed to resolve web entry : "
                                                                    e)
                                                                   (processing-ended)
                                                                   (events/on-error! e)
                                                                   )))}))}
            (loc/tr :web-form-resolution/discard)]]
          [:div
           (if new-company?
             [button/primary-solid
              {:class-name "ms-1"
               :disabled?  disabled?
               :on-click   (fn [_]
                             (processing-started)
                             (resolve-webentry! task
                                                false
                                                existing-company-id
                                                (fn [_]
                                                  (processing-ended)
                                                  (events/close-curtain!))
                                                (fn [e]
                                                  (logging/warn "Failed to resolve web entry : " e)
                                                  (processing-ended)
                                                  (events/on-error! e)
                                                  )))}
              (loc/tr :web-form-resolution/add-to-database)]
             [button/primary-solid
              {:class-name "ms-1"
               :tooltip (loc/tr :web-form-resolution/update-tooltip)
               :disabled?  disabled?
               :on-click   (fn [_]
                             (processing-started)
                             (resolve-webentry! task
                                                false
                                                existing-company-id
                                                (fn [_]
                                                  (processing-ended)
                                                  (events/close-curtain!)
                                                  (fn [e]
                                                    (logging/warn "Failed to resolve web entry : "
                                                                  e)
                                                    (processing-ended)
                                                    (events/on-error! e)))))}
              (loc/tr :web-form-resolution/update-company)])]]
         [:h3.text-uppercase.mt-3 [:strong (loc/tr :web-form-resolution/web-form-details)]]
         (when allow-contact?
           [:p
            [:i.fal.fa-check-square] " " (loc/tr :webentry/has-allowed-contact)])
         (when-not (string/blank? message-from-sender)
           [:div.webentry-curtain-message-from-sender
            [:div.message-from-sender-label
             (loc/tr :web-form-resolution/message-from-sender)]
            [:div.message-from-sender
             (str "\"" message-from-sender "\"")]])
         [webentry-fields task]
         [contact-view task]
         (doall
          (for [attachment (-> task
                               :common/attachments)]
            ^{:key attachment}
            [attachments/attachment-view
             {:attachment (get-in @session/entities [attachment])}]))]))))

(defn view
  [{:keys [webentry-task on-close! resolve-webentry!] :as view-args}]
  (let [close-modal! (fn [_] (when on-close! (on-close!)) (events/close-curtain!))]
    [modal/view
     {:visible?      (events/open?)
      :hide!         close-modal!
      :backdrop      "static"
      :close-button? true}
     (loc/tr :web-form-resolution/curtain-title)
     (cond (or (nil? webentry-task)
               (:common/disabled? webentry-task))
           [:div (loc/tr :web-form-resolution/task-discarded)]
           (:task/completed? webentry-task) [:div (loc/tr :web-form-resolution/task-completed)]
           :else
           [webentry-resolution-view
            {:task              webentry-task
             :resolve-webentry! resolve-webentry!}])
     nil]))

